import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=76ec0e30"
import script from "./PropertyDetail.vue?vue&type=script&lang=js"
export * from "./PropertyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports